import type { AcuityResolutionPayload, AcuityResolutionResponse, UUID } from "@/core/types";
import { api } from "@/api";

export type AcuityResolutionVariables = {
  data: AcuityResolutionPayload;
  patientId: UUID;
};

export async function postAcuityResolution({
  data,
  patientId,
}: AcuityResolutionVariables): Promise<AcuityResolutionResponse> {
  return api.acuityTyped.post_acuity_resolution({
    data,
    params: { showLoader: false },
    patientId,
  });
}
